import axios from "axios";

export default {
  get(id) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/parametros-empresa/${id}`, headerAuth)
      .then((result) => {
        console.log(result);
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  update(parametrosEmpresa) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .put(
        `api/parametros-empresa/${parametrosEmpresa.empresaId}`,
        parametrosEmpresa,
        headerAuth
      )
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
